<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Atividades") }}</h1>

    <ImpressaoAtividades
      v-if="showImpressaoAtividades"
      :filtroTipo="filtroTipos"
      :search="search"
      :filtroDatas="filtroDatas"
      :filtroStatus="filtroStatus"
      @voltar="showImpressaoAtividades = false"
    />
    <b-card v-else class="shadow">
      <div class="list-unidades-component">
        <div class="row">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between mb-4">
              <router-link
                class="btn btn-primary btn-sm"
                to="/dashboard/atividades/add"
              >
                <i class="fas fa-plus-square" />
                {{ $t("Cadastrar") }}
              </router-link>

              <div>
                <b-button-group>
                  <b-button
                    variant="outline-dark"
                    :class="viewFilterReport === true ? 'active' : ''"
                    @click="viewFilters"
                  >
                    <i class="fas fa-filter"></i>
                    {{ $t("Filtros") }}
                  </b-button>
                  <b-button variant="outline-dark" @click="print()">
                    <i class="fas fa-print"></i>
                  </b-button>
                  <b-button
                    variant="outline-dark"
                    @click="exportar()"
                    :title="$t('Exportar')"
                    v-b-tooltip.hover
                  >
                    <i class="fas fa-file-excel"></i>
                  </b-button>
                </b-button-group>

                <button class="btn btn-success btn-sm ml-4" @click="print()">
                  Gerar Impressão
                </button>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="viewFilterReport">
            <!-- Filtros -->
            <form @submit.prevent="getItens" ref="addItem">
              <div class="row">
                <form-calendar
                  v-model="data_inicio"
                  grid="3"
                  label="Data inicial"
                  :max-date="dataNow"
                />

                <form-calendar
                  v-model="data_fim"
                  grid="3"
                  label="Data final"
                  :required="verificaDataInicial"
                  :min-date="data_inicio"
                  :max-date="dataNow"
                />

                <form-select
                  v-model="filtroStatus"
                  grid="6"
                  label="Status"
                  :itens="status"
                  :loading="loadingStatus"
                  :disabled="loadingStatus"
                  multiple
                />

                <form-select
                  v-model="filtroTipos"
                  label="Filtrar por Tipo"
                  grid="12"
                  :itens="tipos"
                  :disabled="loadingSearchTipos"
                  :loading="loadingSearchTipos"
                  :multiple="true"
                />

                <div class="col-md-12">
                  <label><b>Pesquisar</b></label>
                  <div class="input-group">
                    <b-input
                      placeholder="No campo acima você pode pesquisar por: No campo acima você pode pesquisar por: Título ou Tema"
                      class="form-control search-input"
                      type="text"
                      v-model="search"
                      aria-describedby="input-search"
                      @keydown.enter.prevent="getAnalytics"
                    />
                  </div>
                  <p class="small text-muted">
                    No campo acima você pode pesquisar por: Título ou Tema.
                  </p>
                </div>
              </div>
              <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                  <button
                    class="btn btn-default"
                    @click.prevent="limparFiltros(), (viewFilterReport = false)"
                  >
                    <i class="fas fa-times"></i>
                  </button>

                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click.prevent="limparFiltros()"
                  >
                    {{ $t("Limpar Filtros") }}
                  </button>

                  <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                  >
                    <i class="fas fa-chart-bar"></i>
                    {{ $t("Gerar Relatório") }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-12">
            <loading-animation
              :active.sync="loading"
              :is-full-page="false"
              :opacity="1"
              color="#5895FF"
            />
            <print-content>
              <b-table
                :fields="[
                  {
                    key: 'titulo',
                    label: $t('Detalhes'),
                  },
                  {
                    key: 'participantes_array',
                    label: $t('Participantes'),
                  },
                  {
                    key: 'data',
                    label: $t('Data e Hora'),
                  },
                  {
                    key: 'status',
                    label: $t('Status'),
                  },
                  {
                    key: 'actions',
                    label: '',
                    class: 'text-right no-print',
                    thStyle: {
                      width: '95px',
                      minWidth: '95px',
                    },
                  },
                ]"
                :items="itemList"
                :responsive="true"
                striped
                hover
                show-empty
                small
                outlined
                stacked="xs"
                table-class="mb-3"
              >
                <template v-slot:cell(titulo)="data">
                  Tipo:
                  <strong>
                    {{ data.item.tipo }}
                  </strong>
                  <br />
                  <div v-if="data.item.tema">
                    Tema:
                    <strong> {{ data.item.tema }} </strong>
                  </div>
                  <div v-else>
                    Título:
                    <strong> {{ data.item.titulo }} </strong>
                  </div>
                  Responsável:
                  <strong>
                    {{ data.item.tecnico.nome }} 
                  </strong> - <span>{{ data.item.tecnico.profissao ?? 'Não informado' }}</span>
                  <br />
                  Protocolo:
                  <strong> {{ data.item.protocolo }} </strong>
                </template>
                <template v-slot:cell(participantes_array)="data">
                  <strong>
                    <a
                      href="#"
                      @click.prevent="
                        listParticipantes(data.item.participantes_array, data.item.outros_participantes)
                      "
                    >
                      <i class="fas fa-search-plus"></i>
                      Ver todos ({{
                        data.item.count_participantes + data.item.count_outros_participantes
                      }})
                    </a>
                  </strong>
                </template>
                <template v-slot:cell(data)="data">
                  <strong>{{ data.value | formatDate() }}</strong>
                  <strong>{{ data.item.hora_print }}</strong>
                </template>
                <template v-slot:cell(status)="data">
                  <span v-html="data.item.status_nome"></span>
                </template>

                <template v-slot:cell()="data">
                  <b-button
                    :title="$t('Editar')"
                    :to="'/dashboard/atividades/edit/' + data.item.id"
                    class="px-2 mb-0"
                    size="xs"
                    type="button"
                    v-b-tooltip.hover
                    variant="success"
                    v-if="
                      verifyEditPermission(
                        data.item.user_id,
                        data.item.responsavel.id,
                        data.item.participantes_array
                      )
                    "
                  >
                    <i class="mdi mdi-square-edit-outline" />
                  </b-button>

                  <b-button
                    :title="$t('Visualizar e Imprimir')"
                    :to="'/dashboard/atividades/show/' + data.item.id"
                    class="px-2 mb-0"
                    size="xs"
                    type="button"
                    v-b-tooltip.hover
                    variant="primary"
                    v-else
                  >
                    <i class="mdi mdi-eye" />
                  </b-button>
                </template>
                <template v-slot:empty="scope">
                  <div class="text-center my-5">
                    <img
                      :alt="$t('No results')"
                      class="mb-5"
                      src="/img/icons/robot.svg"
                      style="max-height: 165px"
                    />
                    <h3 class="bold">
                      {{ $t("No records found") }}
                    </h3>
                  </div>
                </template>
              </b-table>
            </print-content>
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-12">
                <div class="form-group d-inline-flex mb-0">
                  <select
                    class="form-control"
                    style="width: 70px"
                    v-model="perPage"
                    v-on:change="getItens"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                </div>
                <div class="d-inline-flex ml-2">
                  <b-pagination
                    :per-page="perPage"
                    :total-rows="pagination.total"
                    @change="changePage"
                    v-model="page"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                <div class="float-lg-right">
                  {{ $t("Showing page") }}
                  {{ pagination.currentPage }}
                  {{ $t("of") }}
                  {{ pagination.totalPages }}
                  {{ $t("pages in") }}
                  {{ pagination.total }}
                  {{ $t("records") }}
                </div>
              </div>
            </div>
          </div>
          <router-view />
        </div>
      </div>
    </b-card>
    <ModalVerParticipantes
      :participantes="participantes"
      :usuariosparticipantes="usuarios_participantes"
      :loading="loadingSearchTecnicos"
    />
  </div>
</template>

<script>
import ModalVerParticipantes from "./includes/ModalVerParticipantes";
import ImpressaoAtividades from "./ImpressaoAtividades";
export default {
  name: "Atividades",
  metaInfo() {
    return {
      title: this.$i18n.t("Gestão de Atividades"),
    };
  },
  components: {
    ModalVerParticipantes,
    ImpressaoAtividades,
  },
  data() {
    return {
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      itemList: [],
      participantes: [],
      usuarios_participantes: [],
      filtro: null,
      user_id: null,
      tecnico_id: null,
      loadingSearchTecnicos: false,
      tecnicos: [],

      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTipos: true,
      loadingStatus: false,

      data_inicio: "",
      data_fim: "",
      dataNow: moment().format("YYYY-MM-DD"),
      verificaDataInicial: false,
      viewFilterReport: false,
      status: [],
      tipos: [],
      unidades: [],
      filtroDatas: [],
      filtroStatus: [],
      filtroTipos: [],
      filtroUnidades: [],
      showImpressaoAtividades: false,
    };
  },
  mounted() {
    this.getItens();
    this.getTecnicos();
    this.getStatus();
    this.getUnidades();
    this.getTipos();
  },
  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getItens();
      }
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/atividades", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            filtroStatus: this.filtroStatus,
            filtroTipos: this.filtroTipos,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    getItens() {
      this.loading = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/atividades", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            filtroStatus: this.filtroStatus,
            filtroTipos: this.filtroTipos,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.itemList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getItens();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getTecnicos() {
      this.tecnicos = [];
      this.loadingSearchTecnicos = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`)
        .then((response) => {
          this.tecnicos = response.data;
        })
        .finally(() => (this.loadingSearchTecnicos = false));
    },

    listParticipantes(tecnicos = [], outros = []) {
      this.$bvModal.show("modalVerParticipantes");

      // Agora técnicos já vêm com dados completos
      this.participantes = tecnicos;

      // Outros participantes são nomes simples (strings)
      this.usuarios_participantes = outros.map(nome => ({
        value: nome
      }));
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/report/status/atividades`)
        .then((response) => {
          this.status = response.data;
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },
    getTipos() {
      this.loadingSearchTipos = true;
      axios
        .get(`api/dashboard/report/atividades/tipos`)
        .then((response) => {
          this.tipos = response.data;
        })
        .finally(() => (this.loadingSearchTipos = false));
    },
    limparFiltros() {
      //   this.filtros = {};
      this.search = "";
      this.data_inicio = "";
      this.data_fim = "";

      this.filtroDatas = [];
      this.filtroStatus = [];
      this.filtroTipos = [];
      this.filtroUnidades = [];

      this.getItens();
    },
    viewFilters() {
      this.viewFilterReport = !this.viewFilterReport;
    },
    verifyEditPermission(user, tecnico, participantes) {
      const tecnicoInscrito = participantes.filter((id) => {
        return id === this.tecnico_id;
      });

      return tecnicoInscrito.length > 0 || this.user_id == user ? true : false;
    },
    print() {
      this.showImpressaoAtividades = true;
    },
  },
};
</script>
